import formatDate from '@ps-int/ufo-helpers/lib/date/date-to-string';

import { i18n } from '../../../shared/helpers/i18n';

/**
 * Скачивает файл, формируя его из переданной строки.
 *
 * @param {string} text
 * @param {string} fileType https://www.iana.org/assignments/media-types/media-types.xhtml
 * @param {string} fileName
 */
function downloadString(text: string, fileType: string, fileName: string) {
    const blob = new Blob([text], { type: fileType });

    const a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
}

export const downloadChatHistoryFile = (chatHistory: string) => {
    const prefix = i18n('record', 'file-name-prefix');
    const date = formatDate(new Date(), 'DD.MM.YYYY HH-mm-ss');
    const postfix = i18n('record', 'file-name-postfix-chat');

    return downloadString(chatHistory, 'text/plain', `${prefix} ${date} - ${postfix}.txt`);
};
